export function getExceptionMap(exceptionList) {
  let result = {};
  exceptionList.forEach(exception => {
    if (!result[exception.type]) result[exception.type] = [];
    let found = (exception.type === "LINK_DISABLE" && exception.itemId === null)
      ? result[exception.type].find(r => r.itemName === exception.itemName)
      : result[exception.type].find(r => r.itemId === exception.itemId);
    if (found)
      (exception.affectedItemType === "bundleId" 
        ? found.affectedBundleIdList 
        : found.affectedTestIdList
      ).push(exception.affectedItemId);
    else {
      let newException = {
        id: exception.id,
        type: exception.type,
        itemId: exception.itemId,
        itemName: exception.itemName,
        affectedBundleIdList: [],
        affectedTestIdList: []
    };
    exception.affecteditemType === "bundleId" 
        ? newException.affectedBundleIdList = [exception.affectedItemId]
        : newException.affectedTestIdList = [exception.affectedItemId];
    result[exception.type].push(newException);
    }
  });
  return result;
}